import React from "react";
import IconTextCard, {
  IconTextCardProps,
} from "@/components/ui/icon-text-card";
import { cn } from "@/lib/utils";

export interface BenefitsProps {
  id?: string;
  className?: string;
  backgroundColor?: "white" | "light-orange";
  heading?: string;
  description?: string;
  items?: IconTextCardProps[];
}
const Benefits: React.FC<BenefitsProps> = ({
  id = "benefits",
  className,
  backgroundColor = "white",
  heading = "Heading",
  description = "Description",
  items = [
    {
      icon: "plus",
      title: "Card 1",
      description: "Card Description 1",
    },
    {
      icon: "plus",
      title: "Card 2",
      description: "Card Description 2",
    },
    {
      icon: "plus",
      title: "Card 3",
      description: "Card Description 3",
    },
  ],
}) => {
  return (
    <section
      id={id}
      aria-label={id}
      className={cn(
        backgroundColor === "white" && "bg-white",
        backgroundColor === "light-orange" && "bg-primary-100",
        className
      )}
    >
      <div className="mx-auto flex max-w-lg flex-col gap-6 p-4 md:gap-10 md:px-6 md:py-8 lg:gap-14 lg:px-3 lg:py-10">
        <div className="flex flex-col gap-2 lg:gap-4">
          <h2 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-3 lg:text-heading-2">
            {heading}
          </h2>
          <p className="font-montserrat text-subheading-3-400 text-neutral-500 lg:text-subheading-2">
            {description}
          </p>
        </div>
        <div className="flex flex-col gap-6 md:flex-row md:gap-8 md:px-4 md:*:flex-1 lg:gap-16 lg:px-8">
          {items?.map((benefit, index) => (
            <IconTextCard
              key={`${benefit.title}-${index}`}
              {...benefit}
            />
          ))}
        </div>{" "}
      </div>
    </section>
  );
};

export default Benefits;
